import { render } from "./PageLogs.vue?vue&type=template&id=6467ae42&scoped=true"
import script from "./PageLogs.vue?vue&type=script&lang=js"
export * from "./PageLogs.vue?vue&type=script&lang=js"

import "./PageLogs.vue?vue&type=style&index=0&id=6467ae42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6467ae42"]])

export default __exports__